import {
  reactive, ref, computed,
} from '@vue/composition-api'
import moment from 'moment-timezone'
import { successNotification, errorNotification } from '@/utils/toast-notifications'
// import { dateFormat } from '@/utils/date-format'
import router from '@/router'

export default function useVersionForm(props, ctx) {
  const routeQuery = ctx.root.$route.query
  const rateOptions = [
    {
      text: 'Percentage',
      value: 'percentage',
    },
    {
      text: 'Fixed',
      value: 'fixed',
    },
  ]
  const versionFormRef = ref(null)
  const isPublished = ref(false)
  const responseVersion = ref({})
  const version = ref({
    label: '',
    slug: '',
    published: false,
    effective_date_time: new Date(),
    zone: ctx.root.$route.query.zone,
    service_class: ctx.root.$route.query.service,
    settings: {
      minimum_amount: null,
      tax_amount: null,
      open_meter_amount: null,
      admin_commission: null,
      estimates: {
        rate: 'percentage',
        value: null,
        value_upper: null,
      },
      arrival: {
        amount_per_minute: null,
        free_waiting_time: null,
        maximum_time_threshold: null,
      },
      upfront_estimates: {
        active: false,
        minimum_distance_threshold: null,
        distance: {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        },
        time: {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        },
      },
      drop_zones: {},
      peak_factors: [],
      time_slicings: [],
      distance_slicings: [],
      journey_wait_time: [],
    },
    business_id: routeQuery.businessId,
  })

  const distanceLabeling = computed(() => (version.value.settings.upfront_estimates.distance?.rate === 'percentage' ? '(%)' : '(KM)'))
  const timeLabeling = computed(() => (version.value.settings.upfront_estimates.time?.rate === 'percentage' ? '(%)' : '(Minute)'))
  const convertTime = (fromTimeZone = 'Asia/Amman', toTimeZone = 'GMT') => {
    const factors = version.value.settings.peak_factors
    for (let i = 0; i < factors.length; i += 1) {
      for (let j = 0; j < factors[i].config.rules.length; j += 1) {
        const rule = factors[i].config.rules[j]
        const fromTime = moment.tz(rule.from_hour, 'HH:mm', fromTimeZone)
        const toTime = moment.tz(rule.to_hour, 'HH:mm', fromTimeZone)
        factors[i].config.rules[j].from_hour = fromTime.tz(toTimeZone).format('HH:mm')
        factors[i].config.rules[j].to_hour = toTime.tz(toTimeZone).format('HH:mm')
      }
    }
  }

  const effectiveDate = ref(null)
  const effectiveTime = ref(null)
  // watch([effectiveDate, effectiveTime], ([dateVal, timeVal]) => {
  //   if (dateVal && timeVal) {
  //     version.value.effective_date_time = new Date(`${dateFormat(dateVal)} ${timeVal}`)
  //   }
  // }, { immediate: true })
  const fetchingVersion = ref(false)
  fetchingVersion.value = true
  const reqTemp = {
    versionId: null,
  }
  if (!props.isNew) {
    reqTemp.versionId = ctx.root.$route.params.id
  } else {
    reqTemp.zone = routeQuery.zone
    reqTemp.service = `${routeQuery.service}::${routeQuery['service-class']}`
  }
  ctx.root.$store.dispatch('versions/getVersion', reqTemp).then(res => {
    version.value = { ...res.data.data, business_id: routeQuery.businessId }
    responseVersion.value = { ...res.data.data }
    if (version.value.settings?.upfront_estimates && Object.keys(version.value.settings?.upfront_estimates).length) {
      if (version.value.settings?.upfront_estimates?.time?.rate === 'fixed') {
        version.value.settings.upfront_estimates.time.maximum /= 60
        version.value.settings.upfront_estimates.time.minimum /= 60
      }
    }
    if (!('upfront_estimates' in version.value.settings)) {
      version.value.settings.upfront_estimates = reactive({
        active: false,
        minimum_distance_threshold: null,
        distance: {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        },
        time: {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        },
      })
    } else {
      if (version.value.settings.upfront_estimates.distance === null) {
        version.value.settings.upfront_estimates.distance = {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        }
      }
      if (version.value.settings.upfront_estimates.time === null) {
        version.value.settings.upfront_estimates.time = {
          rate: 'percentage',
          minimum: null,
          maximum: null,
        }
      }
    }
    convertTime('GMT', 'Asia/Amman')
    if (!props.isNew) {
      isPublished.value = version.value.published
    } else {
      isPublished.value = false
      version.value.published = false
    }
    if (!props.isNew) {
      version.value.effective_date_time = new Date(`${res.data.data.effective_date_time}`)
      // effectiveDate.value = version.value.effective_date_time
      // effectiveTime.value = new Date(version.value.effective_date_time).toLocaleTimeString('en', { timeStyle: 'short', hour12: false })
    } else {
      version.value.effective_date_time = null
      // effectiveDate.value = ''
      // effectiveTime.value = ''
    }
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    fetchingVersion.value = false
  })

  const zones = reactive({})
  const fetchingZones = ref(false)
  const zonesNames = ref([])
  const fetchZones = async () => {
    try {
      fetchingZones.value = true
      const res = await ctx.root.$store.dispatch('zones/fetchZones')
      zonesNames.value = [...new Set(res.map(el => `${el.country}::${el.city}`))]
      zonesNames.value.forEach(name => {
        zones[name] = null
      })
    } catch (error) {
      console.log(error)
    } finally {
      fetchingZones.value = false
    }
  }
  const submitting = ref(false)

  const submitVersion = async () => {
    const valid = await versionFormRef.value.validate()
    if (!valid) return
    try {
      const temp = {
        ...version.value,
        settings: {
          ...version.value.settings,
          upfront_estimates: {
            ...version.value.settings.upfront_estimates,
            time: {
              ...version.value.settings.upfront_estimates.time,
            },
            distance: {
              ...version.value.settings.upfront_estimates.distance,
            },
          },
        },
      }
      if (!temp.settings.upfront_estimates.active) {
        if (!temp.settings.upfront_estimates.minimum_distance_threshold) {
          temp.settings.upfront_estimates.minimum_distance_threshold = null
        }
        // Backend responds with data as null
        if (responseVersion.value.upfront_estimates?.time === null && !temp.settings.upfront_estimates.time.maximum && !temp.settings.upfront_estimates.time.minimum) {
          temp.settings.upfront_estimates.time = null
        }
        if (responseVersion.value.upfront_estimates?.distance === null && !temp.settings.upfront_estimates.distance.maximum && !temp.settings.upfront_estimates.distance.minimum) {
          temp.settings.upfront_estimates.distance = null
        }
        // Backend responds with valid data and the admin clears it
        if (!temp.settings.upfront_estimates.time.maximum && !temp.settings.upfront_estimates.time.minimum) {
          temp.settings.upfront_estimates.time = null
        }
        if (!temp.settings.upfront_estimates.distance.maximum && !temp.settings.upfront_estimates.distance.minimum) {
          temp.settings.upfront_estimates.distance = null
        }
      }

      // Convert to seconds
      if (temp.settings.upfront_estimates?.time?.rate === 'fixed') {
        temp.settings.upfront_estimates.time.maximum *= 60
        temp.settings.upfront_estimates.time.minimum *= 60
      }
      temp.effective_date_time = new Date(version.value.effective_date_time).toISOString()
      convertTime()
      submitting.value = true
      if (props.isNew) {
        const resp = await ctx.root.$store.dispatch('versions/createVersion', temp)
        const id = resp?.data?.data?.id
        successNotification('Version created successfully')
        router.push({ path: `/businesses/versions/edit/${id}?businessId=${routeQuery.businessId}` })
      } else {
        await ctx.root.$store.dispatch('versions/editVersion', { id: ctx.root.$route.params.id, version: temp })
        successNotification('Version edited successfully')
      }
    } catch (error) {
      console.log(error)
      const errorMsg = error?.response?.data?.error?.detail?.error
      let message = error?.response?.data?.error?.detail?.message
      if (errorMsg && errorMsg.includes('ix_pricing_versions_slug')) {
        message = 'The version slug already exists'
      }
      if (errorMsg && errorMsg.includes('ix_pricing_versions_effective_date_time')) {
        message = 'Effective Date Time already exists'
      }
      errorNotification(message || 'Failed')
      console.error(errorMsg || error.message)
    } finally {
      convertTime('GMT', 'Asia/Amman')
      submitting.value = false
    }
  }
  fetchZones()
  return {
    submitVersion,
    fetchingZones,
    zones,
    zonesNames,
    submitting,
    rateOptions,
    version,
    effectiveDate,
    effectiveTime,
    versionFormRef,
    fetchingVersion,
    isPublished,
    distanceLabeling,
    timeLabeling,
  }
}
